function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 176.03 255.19"
}, props), React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("path", {
  strokeWidth: "4.5",
  d: "M162.25 172.94a80 80 0 0 1-160 2v-2a80 80 0 0 1 160 0z"
}), React.createElement("circle", {
  cx: "105.46",
  cy: "196.17",
  r: "26.91",
  strokeWidth: "4.5"
}), React.createElement("path", {
  strokeWidth: "4.5",
  d: "M132.16 192.77a26.91 26.91 0 0 1-52.87 2.87c-.48-2-.52-.71-.52-2.87m-66.08-57.71a23.28 23.28 0 0 1 3.94-.34 22.66 22.66 0 1 1-14.38 40.16m142.89-50.7a15.79 15.79 0 1 1-22-20"
}), React.createElement("path", {
  strokeWidth: "4.5",
  d: "M2.25 169.26s5.69 7.83 21.68 3.68c15.36-4 12.91-25.79 12.91-25.79m67.77-55.36C103 87 96.54 60 119.6 24.28c0 0 12.35-1.94 25.79 6 10.43 6.54 14.88 18.64 14.88 18.64-20.91 37-49.67 42.72-54.66 43.52 0-.04-.88-.27-1-.65z"
}), React.createElement("circle", {
  cx: "123.96",
  cy: "60.67",
  r: "11",
  strokeWidth: "4.5",
  transform: "rotate(-14 124 60.7)"
}), React.createElement("path", {
  strokeWidth: "4.5",
  d: "M153.83 56.87s-11.59-22.95-39.29-24M149.18 74s13.43-9.72 17.51-24.44a8.4 8.4 0 0 1 7.09-2.15s-2.05 25.44-24.6 26.59zm-47.42-28.68s2.37-16.41 13.51-26.87a8.4 8.4 0 0 0-1.39-7.27S92.3 24.81 101.76 45.32zM86.11 81.35s11.58-12.58 1.26-18.12-5 7.05-5 7.05 18.38-3 3-23m64.79 49.17s-6.78-7.29-10.47-1.55 3.87 3.24 3.87 3.24-.89-10.8-13.22-2.79"
}), React.createElement("path", {
  strokeWidth: "5",
  d: "M134.81 14.5v-12"
}), React.createElement("path", {
  strokeWidth: "4.5",
  d: "M152.98 20.41l6.97-10.78"
}))));